export const batteryMetricOption = {
  value: 'battery',
  label: 'ولتاژ باتری (V)',
};

export function metricDisplayName(metric) {
  return metric === batteryMetricOption.value
    ? batteryMetricOption.label
    : metric;
}

export function withSystemMetrics(options = []) {
  const withoutBattery = options.filter(
    (option) => option.value?.toLowerCase() !== batteryMetricOption.value,
  );
  return [...withoutBattery, batteryMetricOption];
}
